const PageSection = ({ children, className }) => {
    return (
      <div className={`flex-none py-3 px-5 border-b border-zinc-200 ${className}`}>
            {children}
        </div>
    );
};

export default PageSection;